module.exports = __webpack_public_path__ + "static/img/product_banner_17_zh.c2f8d5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_17_zh.png
// module id = SRzW
// module chunks = 34